import { createFileRoute, notFound, redirect } from "@tanstack/react-router";

import { SearchPage } from "@/features/directory/modules/search-page/search-page";
import { directoryCitiesRequest, loadSearchPage } from "@/features/directory/utils/load-search-page";
import { searchHead, searchTitle } from "@/features/directory/utils/search-head";
import { ALL_SERVICES, serviceFromPath } from "@/features/directory/utils/search-path";
import { localizePath } from "@/lib/locale";
import { getLocale } from "@/paraglide/runtime.js";

/** Everyone who offers one service, wherever they are: `/search/manual-therapy` (ADR 0042). */
export const Route = createFileRoute("/(public)/search/$service/")({
  staticData: { ownAlternates: true },
  loader: async ({ params }) => {
    if (params.service === ALL_SERVICES) throw redirect({ href: localizePath("/search", getLocale()), statusCode: 301 });
    const service = serviceFromPath(params.service);
    if (!service) throw notFound();
    const search = { service };
    const [{ data: cities }, page] = await Promise.all([directoryCitiesRequest().send(), loadSearchPage(search)]);
    return { crumb: searchTitle(search), search, cities: cities ?? [], ...page };
  },
  head: ({ loaderData }) =>
    loaderData ? searchHead({ search: loaderData.search, total: loaderData.result?.total ?? 0 }) : {},
  component: ServiceRoute,
});

function ServiceRoute() {
  const { search, result, firstTimes, cities } = Route.useLoaderData();
  return <SearchPage search={search} result={result} firstTimes={firstTimes} cities={cities} />;
}
